import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';  // Importando o CSS do Bootstrap
// cookies
import Cookies from 'js-cookie';
import './TabComponent.css';
import '../../styles/global.css';


// Importar componentes de páginas
import { useNavigate } from 'react-router-dom';

const TabComponent = () => {

  console.log('!!! Entrou em TabComponent.js !!!');

  const navigate = useNavigate();  // Hook para navegação
  const [activeTab, setActiveTab] = useState('checkin');  // Estado para gerenciar a aba ativa

  // dados do usuário, inclusive se for cliente logado
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

  // const dadosCookies = JSON.parse(Cookies.get('dadosCheckin'))

  const dadosCheckinRaw = Cookies.get('dadosCheckin');
  const dadosCookies = dadosCheckinRaw ? JSON.parse(dadosCheckinRaw) : null;


  console.log('dadosCookies: ');
  console.log(dadosCookies);

  console.log('userData: ');
  console.log(userData);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Navegar para a rota correspondente quando a aba for clicada
    if (tab === 'checkin') {
      navigate('/');
    } else if (tab === 'sobre') {
      navigate('/sobre');
    } else if (tab === 'buscar') {
      navigate('/buscar');
    } else if (tab === 'area-restrita') {
      navigate('/area-restrita');
    }
  };

  return (
    <div className="tab-component-container">

    {/* Abas fixadas na parte inferior */}
    <ul className="tab-menu-rodape">
      <li className="menu-rodape-item">
        <a
          className={`tab-menu-rodape-link ${activeTab === 'checkin' ? 'active' : ''}`}
          onClick={() => handleTabChange('checkin')}
        >
          {
            dadosCookies && dadosCookies.statusCheckin == 'usuarioCheckado'
            ?
              <label htmlFor="numeroMesa">Menu</label>
            :
              <label htmlFor="numeroMesa">Checkin</label>
          }          
        </a>
      </li>

      {/* <li className="menu-rodape-item">
        <a
          className={`tab-menu-rodape-link ${activeTab === 'buscar' ? 'active' : ''}`}
          onClick={() => handleTabChange('buscar')}
        >
          Buscar
        </a>
      </li>
       */}
      <li className="menu-rodape-item">
        <a
          className={`tab-menu-rodape-link ${activeTab === 'sobre' ? 'active' : ''}`}
          onClick={() => handleTabChange('sobre')}
        >
          Sobre
        </a>
      </li>
      
      <li className="menu-rodape-item">
        <a
          className={`tab-menu-rodape-link ${activeTab === 'area-restrita' ? 'active' : ''}`}
          onClick={() => handleTabChange('area-restrita')}
        >
          {
            userData && userData.statusUsuario == 'logado'
            ?
              <label htmlFor="numeroMesa">Configurações</label>
            :
              <label htmlFor="numeroMesa">Login</label>
          }
        </a>
      </li>
    </ul>
    </div>

  );
};

export default TabComponent;
